import { maycaApi, maycaApiWithoutAuth } from "../helpers/api_helper";

export class UserByStoreRepository {
  endpoint = "/user";

  async getUserByStore(params) {
    const response = await maycaApi.get(this.endpoint, { params });
    return response.data;
  }

  async create(data) {
    const response = await maycaApi.post(this.endpoint, data);
    return response;
  }

  async delete(id) {
    const response = await maycaApi.delete(`${this.endpoint}/${id}`);
    return response.data;
  }

  async update( roleId, userId, data ) {
    const response = await maycaApi.patch(`${this.endpoint}/user/${userId}/${roleId}`, data);
    return response.data;
  }

  async updateRole( roleId, userId ) {
    const response = await maycaApi.patch(`${this.endpoint}/change-rol/${userId}/${roleId}`);
    return response.data;
  }

  async sendCode(email) {
    const response = await maycaApi.post(
      `${this.endpoint}/send-reset-pasword-code`,
      { email }
    );
    return response;
  }

  async validateCode(code) {
    const response = await maycaApi.post(
      `${this.endpoint}/validate-code/${code}`
    );
    return response;
  }

  async changePassword(payload) {
    const response = await maycaApi.post(
      `${this.endpoint}/reset-pasword/`,
      payload
    );
    return response;
  }

  async getMyInfoFromApi() {
    return await maycaApi.get(`${this.endpoint}/me`);
  }

  async checkValidity() {
    return await maycaApiWithoutAuth.get(`${this.endpoint}/me`);
  }
  
  async dontAskMoreForMFA() {
    return await maycaApi.patch(`${this.endpoint}/off-mfa`);
  }
}

export default UserByStoreRepository;
